/* eslint-disable i18next/no-literal-string -- theme colours, not user visible */

export const breakpoints = {
  base: '0rem', // very small, smaller than mobile (0px)
  sm: '30rem', // mobile (480px)
  md: '48rem', // tablet (768px)
  lg: '64rem', // laptop small (1024px)
  xl: '75rem', // laptop large + desktop (1200px)
  '2xl': '96rem', // large screen + TV (1536px)
};
